module.exports = __webpack_public_path__ + "img/arrow-simulator.65cb0c90.svg";